export enum TipoEstadoActualTrackingCorteEnum {
  DEFAULT = '',
  ACTIVATED = 'activated',
  CONFIRMED = 'confirmed',
  NORMALIZED = 'normalized',
  ARRIBO_BRIGADA = 'ARRIBO_BRIGADA',
  SIN_FALLAS = 'SIN_FALLAS',
}
